module.exports = __webpack_public_path__ + "static/media/gherkins_350_gr.0e48a56c.png";